
export const TAREAS_ON_GET_REQUESTED ='TAREAS_ON_GET_REQUESTED';
export const TAREAS_ON_GET_SUCCEEDED = 'TAREAS_ON_GET_SUCCEEDED';
export const TAREAS_ON_GET_FAILED = 'TAREAS_ON_GET_FAILED';

export const TAREAS_ON_POST_REQUESTED = 'TAREAS_ON_POST_REQUESTED';
export const TAREAS_ON_POST_SUCCEEDED = 'TAREAS_ON_POST_SUCCEDED';
export const TAREAS_ON_POST_FAILED = 'TAREAS_ON_POST_FAILED';

export const TAREAS_ON_DELETE_REQUESTED = 'TAREAS_ON_DELETE_REQUESTED';
export const TAREAS_ON_DELETE_SUCCEEDED = 'TAREAS_ON_DELETE_SUCCEDED';
export const TAREAS_ON_DELETE_FAILED = 'TAREAS_ON_DELETE_FAILED';
